import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AdminService } from '../../../services/admin.service';
import { Companies, Company } from '../../../interfaces/admin/Company';
import { ServerResponse, ServerResponseObject } from '../../../interfaces/ServerResponse';
import { SearchCompanyComponent } from '../../admin/seach-company/search-company.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NotifyDialogService } from '../../../services/notify-dialog.service';
import { ARE_YOU_SURE, SURE_REMOVE_COMPANY } from '../../../shared/strings';

export interface UserDialogData {
  user_id: string;
  name: string;
  email: string;
  uuid: string;
}

@Component({
  selector: 'app-add-user-company-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    SearchCompanyComponent,
    MatTableModule
  ],
  templateUrl: './add-user-company-dialog.component.html',
  styleUrl: './add-user-company-dialog.component.scss'
})
export class AddUserCompanyDialogComponent {

  ARE_YOU_SURE = ARE_YOU_SURE;
  SURE_DELETE_COMPANY = SURE_REMOVE_COMPANY;

  companyDisplayedColumns: string[] = [
    'company_id',
    'company_name',
    'actions'
  ];

  companyDataSource = new MatTableDataSource<Company>();

  addUserCompanyForm = new FormGroup({
    company_id: new FormControl('', [Validators.required]),
  });

  selectedCompany!: Company;

  constructor(private adminService: AdminService, private notifyDialogService: NotifyDialogService) {
    this.getUserCompany();
   }

  private readonly dialogRef = inject(MatDialogRef<AddUserCompanyDialogComponent>, { optional: true });
  data = inject<UserDialogData>(MAT_DIALOG_DATA);

  isLoading: boolean = false;
  companiesLoading: boolean = false;

  onAddUserCompany(){
    if(!this.addUserCompanyForm.valid)return;
    let company_id = this.addUserCompanyForm.value.company_id;
    this.isLoading = true;
    this.adminService.addUserCompany(company_id!, this.data.email).subscribe({
      next:(ref: any)=>{
        this.getUserCompany();
        this.addUserCompanyForm.reset();
        this.isLoading = false;
      },
      error: ()=>{
        this.isLoading = false;
      }
    });
  }

  getUserCompany() {
    this.companiesLoading = true;
    this.adminService.getUserCompanies(this.data.email).subscribe({
      next: (res: ServerResponse<Company>) => {
        this.companyDataSource.data = res.result;
        this.companiesLoading = false;
      },
      error: () => { 
        this.companiesLoading = false;
      },
    });
  }

  onDeleteCompany(company: Company){
    this.selectedCompany = company;
    this.notifyDialogService.openDialog(ARE_YOU_SURE, SURE_REMOVE_COMPANY.replace("${}", this.selectedCompany.name), true, ()=>{
      this.removeUserCompany();
    });
  }

  removeUserCompany(){
    this.companiesLoading = true;
    this.adminService.removeUserCompany(this.selectedCompany.id, this.data.email).subscribe({
      next: (res: ServerResponseObject<any>)=>{
        this.companiesLoading = false;
        this.getUserCompany();
      },
      error: ()=>{
        this.companiesLoading = false;
      }
    });
  }
}
